import { ALLOWED_PATHS } from '../constant'

export const formatNumber = (number: number) => {
  if (number >= 1000000) {
    return (number / 1000000).toFixed(1) + 'M'
  } else if (number >= 1000) {
    return (number / 1000).toFixed(1) + 'K'
  } else {
    return number
  }
}

export const formatNumberInMillion = (number: any) => {
  return (number / 1_000_000).toFixed(3) + 'M'
}

export function removeHtmlTags(html: string) {
  if (!html) {
    return ''
  }
  return html.replace(/<\/?[^>]+(>|$)/g, '')
}

export function getsliceFilename(text: string) {
  return text.split('/').pop()
}

export const validatePath = (redirectUrl: any) => {
  const path = redirectUrl

  return ALLOWED_PATHS.includes(path)
}

export const formatDecimalValue = (
  value: string | number | null | undefined,
  decimals: number = 3
): string => {
  const number = typeof value === 'number' ? value : parseFloat(value ?? '')
  return !isNaN(number) ? number.toFixed(decimals) : 'N/A'
}
